import React, { forwardRef } from "react";
import { FieldTypes, urlRegexValidator } from "utils/formUtils";

import GenericPullCredentialsForm from "../GenericPullCredentialsForm";
import UltraVioLetMappingForm from "./UltraVioLetMappingForm";

const UltraVioletCredentialsForm = (props, ref) => {
  const fields = [
    {
      name: "apiEndpoint",
      label: "API Endpoint",
      rules: [urlRegexValidator],
      required: true,
    },
    {
      name: "token",
      label: "Token",
      type: FieldTypes.PASSWORD,
      required: true,
    },
    {
      name: "tokenId",
      label: "Token Id",
      type: FieldTypes.PASSWORD,
      required: true,
    },
  ];

  return (
    <GenericPullCredentialsForm
      {...props}
      ref={ref}
      fields={fields}
      MappingForm={UltraVioLetMappingForm}
    />
  );
};

export default forwardRef(UltraVioletCredentialsForm);